export interface Report {
  reportId: number;
  reportName: string;
  projectId: number;
  jobId: string;
  clientName: string;
  siteName: string;
  owner: string;
  reportTypeId: number;
  status: ReportStatus;
  createdBy: string;
  createdDate: string;
  updatedBy: string;
  updatedDate: string;
  pdfFilePath: string;
  docFilePath: string;
  basePdfFilePath:string;
}

export enum ReportStatus {
  Initiated = 1,
  Generated = 2,
  Review = 3,
  Approved = 4,
  Published = 5,
  Failed = 6
}

export interface AddReportRequest {
  reportName: string;
  projectId: number;
  clientId: number;
  locationId: number;
  reportTypeId: number;
  additionalNotes:string;
  status: ReportStatus.Initiated;
  reportMonth:Date,
  stateId:number,
  fileId:string,
  referencePath:string
}